<template>
  <div>
    <div
      :id="card.id"
      :class="`color${color}`"
      class="games-card-wrapper">
      <div
        :class="`bg-color${color}`"
        class="card-image">
        <img
          v-if="card.image_url"
          :src="card.image_url">
      </div>
      <div
        class="card-content"
        tabindex="0">
        <p>Write this in Spanish:</p>
        <div class="test-original-text">
          {{card.initial_sentence}}
        </div>
          <div class="words">
            <div class="destination"></div>
            <div class="origin">
              <div class="container" v-for="word in randomizeVariants" :key="word.uid">
                <span class="word" @action="onWordClicking(word.uid, word.speech_url)">
                  {{word.text}}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="game-card-check-button">
          <button
            :disabled="checkDisabled"
            :class="{disabled : checkDisabled}"
            class="f-button blue"
            @click="onCheckAnswer()">Check Answer</button>
        </div>

        <audio ref="audioPlayer"><source :src="audioURL" type="audio/mpeg"></audio>

        <div v-show="answerState == 'correct'" class="games-card-answered-correctly">
          <span class="games-card-answered-icon"></span> <strong>Correct</strong><br>
        </div>

        <div v-show="answerState == 'incorrect'" class="games-card-answered-incorrectly">
          <span class="games-card-answered-icon"></span> <strong>Incorrect</strong><br>
          <strong>Correct Answer:</strong>

          {{card.correct_answer_text}}
        </div>

        <div v-if="showCorrectAudio" class="games-card-audio">
          <div class="games-card-audio-normal">
            <a
              href="javascript:void(0);"
              :class="{'playing' : isPlaying}"
              @click="onPlayAudio(card.correct_answer_speech_url, 'normal')"
              title="Play Audio"></a>
          </div>

          <div class="games-card-audio-slow">
            <a
              href="javascript:void(0);"
              :class="{'playing' : isPlayingSlow}"
              @click="onPlayAudio(card.correct_answer_slow_speech_url, 'slow')"
              title="Play Audio"></a>
          </div>
        </div>

    </div>
  </div>
</template>


<script>
import $ from 'jquery'
import { wordmoving, resetwords } from '../word_move'
import { shuffle } from 'lodash'

export default {
  props: {
    card: {
      type: Object,
      required: true
    },
    color: {
      type: Number,
      required: true
    },
    cardIndex: {
      type: Number,
      required: true
    },
    sliderNavClick: {
      type: Boolean,
      required: true
    },
    reseted: {
      type: Number,
      required: true
    },
    gameId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      answerWords: this.card.answer_bank,
      chosenAnswerArray: [],
      answerState: '',
      isPlaying: false,
      isPlayingSlow: false,
      audio: {},
      audioURL: ''
    }
  },

  computed: {
    showCorrectAudio() {
      return this.card.correct_answer_speech_url && this.answerState
    },
    randomizeVariants() {
      return shuffle(this.answerWords)
    },

    checkDisabled() {
      if (this.chosenAnswerArray.length > 0) {
        return false
      } else {
        return true
      }
    },

    chosenAnswerText() {
      const chosenAnswersText = this.chosenAnswerArray.map(uid => {
        let text
        this.card.answer_bank.forEach((word, index) => {
          if (word.uid == uid) {
            text = word.text
          }
        })

        return text
      })

      return chosenAnswersText.join(' ')
    }
  },

  watch: {
    sliderNavClick() {
      if (this.sliderNavClick) {
        this.stopPlayingAudio()
      }
    },
    reseted() {
      this.resetAnswers()
    }
  },

  mounted() {
    wordmoving(this.card.id)
    this.audio = this.$refs.audioPlayer
  },

  methods: {
    onWordClicking(id, url) {
      this.createChosenAnswerArray(id)
      this.onPlayWordAudio(id,url)
    },

    createChosenAnswerArray(uid) {
      const index = this.chosenAnswerArray.findIndex((item) => {
        return item == uid
      })
      if (index < 0) {
        this.chosenAnswerArray.push(uid)
      } else {
        this.chosenAnswerArray.splice(index, 1)
      }
    },

    onCheckAnswer() {
      if (this.chosenAnswerText.toLowerCase() == this.card.correct_answer_text.toLowerCase()) {
        this.answerState = 'correct'
      } else {
        this.answerState = 'incorrect'
      }

      this.emitAnswerState()

      this.sliderHeightCalc()
    },

    onPlayAudio(url, speed) {
      this.audioURL = url

      if (speed == 'normal') {
        if (!this.isPlaying) {
          this.isPlayingSlow = false
          this.isPlaying = true
          this.audio.load()
          this.audio.play()

          this.audio.onended = (event) => {
            this.isPlaying = false
          }
        } else {
          this.stopPlayingAudio()
        }
      } else if (speed == 'slow') {
        if (!this.isPlayingSlow) {
          this.isPlaying = false
          this.isPlayingSlow = true
          this.audio.load()
          this.audio.play()

          this.audio.onended = (event) => {
            this.isPlayingSlow = false
          }
        } else {
          this.stopPlayingAudio()
        }
      }
    },

    onPlayWordAudio(uid, url) {
      const index = this.chosenAnswerArray.findIndex((item) => {
        return item == uid
      })
      if (index >= 0) {
        this.audioURL = url
        this.isPlaying = false
        this.isPlayingSlow = false
        this.audio.load()
        this.audio.play()

        this.audio.onended = (event) => {
          this.isPlayingSlow = false
        }
      }
    },

    stopPlayingAudio() {
      this.isPlaying = false
      this.isPlayingSlow = false
      this.audio.pause()
    },

    resetAnswers() {
      this.chosenAnswerArray = []
      resetwords(this.card.id)
      this.answerState = ''
      this.emitAnswerState()
    },

    sliderHeightCalc() {
      // change height after inner content changing
      const that = this
      const $slideshow = $('.slideshow' + this.gameId)

      setTimeout(function() {
        const height = $('#' + that.card.id + '.games-card-wrapper').outerHeight()

        $('.slick-list', $slideshow).animate({height: height}, 300)
      }, 70)
    },

    emitAnswerState() {
      this.$emit('answerState', {state: this.answerState, index: this.cardIndex});
    }
  }
}
</script>
